export { default } from './SimilarTitleDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/SimilarTitleDisplay/index.js